import type { RoleId } from '@ringmaster/shared';
import type { GlyphName, GlyphTone } from '../ui/Glyph.js';

/**
 * Role → ceremony Glyph mapping for the hand screens. This is the sanctioned
 * replacement for ROLE_META.glyph (which is emoji, banned in the UI). Kept local
 * to the client — shared/roles.ts stays engine-neutral.
 */
export const ROLE_GLYPH: Record<RoleId, GlyphName> = {
  WEREWOLF: 'wolfHead',
  SEER: 'seerEye',
  VILLAGER: 'candle',
  // The Whisper — reuse arcana ceremony glyphs (final art in M6). TODO(whisper M6).
  DECEIVER: 'seerEye',
  PALADIN: 'candle',
  // One Night — the Thief's top hat (a card-sharp's disguise) and the Joker's
  // carnival mask. The Joker used to reuse the seer's EYE; once every night role
  // was merged into one parallel beat, the Joker and the real Seer were awake at
  // the same moment wearing the same icon, which read as a bug.
  THIEF: 'topHat',
  JOKER: 'mask',
};

/** Faction-appropriate tone per role. */
export const ROLE_TONE: Record<RoleId, GlyphTone> = {
  WEREWOLF: 'blood',
  SEER: 'arcana',
  VILLAGER: 'gold',
  // The Whisper roles sit in the arcana skin. TODO(whisper M6).
  DECEIVER: 'arcana',
  PALADIN: 'arcana',
  // One Night — village-team swappers get a bone tone (neutral, not clearly
  // wolf or village-safe — matches their ambiguous alignment).
  THIEF: 'bone',
  JOKER: 'bone',
};

/** Faction-appropriate accent color for a revealed role name/row. */
export function roleAccent(role: RoleId): string {
  switch (role) {
    case 'WEREWOLF':
      return 'var(--blood-5, #c22f3e)';
    case 'SEER':
      return 'var(--arcana-3, #8b5cf6)';
    case 'VILLAGER':
      return 'var(--gold-5, #e6b866)';
    // The Whisper roles — arcana accent (final treatment in M6). TODO(whisper M6).
    case 'DECEIVER':
    case 'PALADIN':
      return 'var(--arcana-3, #8b5cf6)';
    // One Night — neutral bone accent (placeholder, no dedicated treatment yet).
    case 'THIEF':
    case 'JOKER':
      return 'var(--state-dead, #9c8f86)';
  }
}
